export default {
    link: [
        {
            linkName: '电脑端',
            linkUrl: '',
        },
        {
            linkName: '易联云',
            linkUrl: '',
        },
        {
            linkName: '芦莺',
            linkUrl: '',
        },
        {
            linkName: '开放平台',
            linkUrl: '',
        },
        {
            linkName: '异常通知',
            linkUrl: '',
        },
    ],
    DEVICE_OPERATE_TYPE: {
        REBOOT: 11,
        SHUTDOWN: 12,
        DELETE: 13,
        CANCEL: 14,
        COPY: 15,
        INPUT: 16,
        CONFIRM: 17,
        PRESS: 18,
        EFFECT: 19,
        VOLUME: 20,
        NAME: 21,
        LOGO: 23,
        DEL_LOGO: 24,
    },
    PLATFORM_APP_LIST: {
        ALL: '5f2f23b573110028493e13a2333c0207',
    },
    /**
     * IS_DIALOG 是否要打开对话框
     *-1:调用授权接口后再次弹出对话框
     * 0:没有对话框
     * 1:选择店铺类型(餐饮，非餐饮)对话框
     * 2:输入门店或者商户ID对话框
     * 3:直接输入门店ID对话框
     * 4:是否购买应用对话框
     * 5:查询打印机对话框
     * 6:选择门店类型（微盟和微盟2）对话框
     */
    APP_LIST: [ // 应用列表
        {
            APP_ID: 'd6804d4a63a77a6787f60fb92868e6ab',
            APP_LOGO: require("@/assets/images/mt.jpg"),
            APP_NAME: '美团外卖',
            APP_TYPE: 1,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 1, // 打印机设置类型
            IS_GOODS_PRINT: 1, // 是否有后厨联选择商品打印
        },
        {
            APP_ID: 'ed55bf16799c8d3d20576723aa9ef374',
            APP_LOGO: require("@/assets/images/mtsg.png"),
            APP_NAME: '美团闪购',
            APP_TYPE: 2,
            IS_DIALOG: -1,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 0, // 是否有后厨联选择商品打印
        },
        {
            APP_ID: 'b5b9951e06ffed4d3304562029700929',
            APP_LOGO: require("@/assets/images/elm.png"),
            APP_NAME: '淘宝闪购·餐饮',
            APP_TYPE: 3,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 1,
        },
        {
            APP_ID: '95f4f5bc96cc1fefbf235aebb62e5260',
            APP_LOGO: require("@/assets/images/elmls.jpg"),
            APP_NAME: '淘宝闪购·零售',
            APP_TYPE: 4,
            IS_DIALOG: 4,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 1,
        },
        {
            APP_ID: '2c903b199b4e925ede4ff3f57b287d71',
            APP_LOGO: require("@/assets/images/jd.jpg"),
            APP_NAME: '京东外卖',
            APP_TYPE: 5,
            IS_DIALOG: 5,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 1,
        },
        {
            APP_ID: 'cba1f7f15cc50fa5e86562cc7bba26bf',
            APP_LOGO: require("@/assets/images/wd.png"),
            APP_NAME: '微店',
            APP_TYPE: 6,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 3,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '5f5ab5e651033d7c07633b5213a80478',
            APP_LOGO: require("@/assets/images/wm.png"),
            APP_NAME: '微盟',
            APP_TYPE: 7,
            IS_DIALOG: 6,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 2,
        },
        {
            APP_ID: 'bb242e9bea6274da31de9725fdf00631',
            APP_LOGO: require("@/assets/images/yz.png"),
            APP_NAME: '有赞',
            APP_TYPE: 8,
            IS_DIALOG: 3,
            PRINTER_SETTING_TYPE: -1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: 'd511155279cf6f3f33cde7c799de01b4',
            APP_LOGO: require("@/assets/images/dy.png"),
            APP_NAME: '抖音来客外卖',
            APP_TYPE: 9,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: 'cf188bcd2e175d695bf5f718b42639e4',
            APP_LOGO: require("@/assets/images/dytg.png"),
            APP_NAME: '抖音来客团购',
            APP_TYPE: 10,
            IS_DIALOG: 1,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: 'e6a63b3f462630c1f668a4da3d55dcc4',
            APP_LOGO: require("@/assets/images/mttg.png"),
            APP_NAME: '美团团购',
            APP_TYPE: 11,
            IS_DIALOG: 1,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '4c50b2a96bf3c0d9c654eb8b1515732e',
            APP_LOGO: require("@/assets/images/sy.png"),
            APP_NAME: '免费试',
            APP_TYPE: 12,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '8944c0ae09035523210e7a4219f662b4',
            APP_LOGO: require("@/assets/images/dy.png"),
            APP_NAME: '抖店外卖',
            APP_TYPE: 13,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '7a77459867e18c0ec07efc553f2856ec',
            APP_LOGO: require("@/assets/images/kwai.png"),
            APP_NAME: '快手团购',
            APP_TYPE: 14,
            IS_DIALOG: 2,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '1d88e53d76e8551754763a1db0b22a95',
            APP_LOGO: require("@/assets/images/ktt.png"),
            APP_NAME: '快团团',
            APP_TYPE: 15,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: -1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '215e1de2d7496d64aca75138cb0ad36b',
            APP_LOGO: require("@/assets/images/xhs.png"),
            APP_NAME: '小红书',
            APP_TYPE: 16,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: -1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '8daa7e557b158b5734b34d80c9af4336',
            APP_LOGO: require("@/assets/images/jdtg.jpg"),
            APP_NAME: '京东团购',
            APP_TYPE: 17,
            IS_DIALOG: 5,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '5ca337859760d1ea70b339c73d62f923',
            APP_LOGO: require("@/assets/images/elmtg.jpg"),
            APP_NAME: '淘宝闪购·团购',
            APP_TYPE: 21,
            IS_DIALOG: 0,
            PRINTER_SETTING_TYPE: 2,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '30c71fe149d8eb4bd05a953c1968ade9',
            APP_LOGO: require("@/assets/images/tmsg.jpg"),
            APP_NAME: '天猫闪购',
            APP_TYPE: 23,
            IS_DIALOG: 5,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 0,
        },
        {
            APP_ID: '14d037b62e016647d88eab0c94b636de',
            APP_LOGO: require("@/assets/images/wm2.jpg"),
            APP_NAME: '微盟2',
            APP_TYPE: 24,
            IS_DIALOG: 6,
            PRINTER_SETTING_TYPE: 1,
            IS_GOODS_PRINT: 3,
        },
    ]
}